import ProjectSession from "../../../../../core/model2/project/project-session"
import getOrderedTags from "./get-ordered-tags"

export default function saveTagsSortPositions(items: any[], tags: ProjectSession[]) {

    const sortPositions = _.map(items, (item:any)=>item.id)

    // collect all tag ids that are not among items (for show less state only visible items are reordered)
    const otherTagsIds = _(getOrderedTags(tags))
        .filter((item:any)=>!sortPositions.includes(item.id))
        .map((item:any)=>item.id)
        .value()

    gd.user.settings.menu.projectsTags.sortPositions = [...sortPositions, ...otherTagsIds]
    gd.user.settings.menu.save()
}
